import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { SignUpButton } from "@faire/retailer/app/visitor/[locale]/(pagesWithModal)/(defaultHeader)/brand/[brandToken]/(rsc)/rsc/_sections/Info/SignUpButton";
import { SignUpElement } from "@faire/retailer/lib/popSignUp";

import * as styles from "./styles.css";

interface IProps {
  brandToken: string | undefined;
  brandName: string | undefined;
}

export const PRODUCT_GRID_CTA_BOTTOM_OFFSET = 100;

export const ProductGridCTA: React.FC<IProps> = ({ brandName, brandToken }) => {
  return (
    <Column className={styles.gradient} data-test-id="product-grid-cta">
      <Column className={styles.container} align="center">
        <Typography
          variant={{
            mobileAndAbove: "pageHeaderSerifRegular",
            tabletAndAbove: "displaySSerifRegular",
            xLargeAndAbove: "displayMSerifRegular",
          }}
          align="center"
        >
          <StrictLocalMsg
            defaultMessage="Explore the full wholesale catalog"
            description={{
              text: "Header text the sign up CTA",
            }}
          />
        </Typography>
        <Spacer height="1x" />
        <Typography
          variant={{
            mobileAndAbove: "paragraphSansRegular",
            xLargeAndAbove: "subheadingSansRegular",
          }}
          align="center"
        >
          <StrictLocalMsg
            defaultMessage="Sign up to unlock wholesale pricing on {brandCompanyName} and thousands of brands on Faire, the marketplace for retailers."
            description={{
              text: "Subheader text for the sign up CTA",
            }}
            values={{ brandCompanyName: brandName || "" }}
          />
        </Typography>
        <Spacer height="3x" />
        <SignUpButton
          brandToken={brandToken}
          element={SignUpElement.BELOW_FOLD}
          sourceId="brand_page_product_grid_cta"
          variant="secondary"
        >
          <StrictLocalMsg
            defaultMessage="Sign up to buy"
            description={{
              text: "Sign up CTA",
            }}
          />
        </SignUpButton>
      </Column>
    </Column>
  );
};
